import React from "react";

const CustomerCategoryDiscountReport = ({ resPacket }) => {
    return (
        <div>
            {resPacket?.length > 0 ? (
                <div className="customTable" id="scroll">
                    <table className="customTable w-100">
                        <thead className="fixed-thead">
                            <tr>
                                <td>SNO.</td>
                                <td>Customer Name</td>
                                <td>Phone</td>
                                <td>Customer Category</td>
                                <td>Item Category</td>
                                <td>Discount Type</td>
                                <td>Discount Value</td>
                                <td>Price List</td>
                            </tr>
                        </thead>
                        <tbody className="body-scroll-custom">
                            {resPacket.map((row, i) => {
                                const categoryTitle = row.categoryDiscountList?.[0]?.categoryTitle || "All";
                                return (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{row.title}</td>
                                        <td>{row.phone}</td>
                                        <td>{row.customerCategory}</td>
                                        <td>{categoryTitle}</td>
                                        <td>{row.discountType || "None"}</td>
                                        <td>{row.discountValue || 0}</td>
                                        <td>{row.itemPriceListTitle}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="customTable" id="scroll">No Data Found.</div>
            )}
        </div>
    );
};

export default CustomerCategoryDiscountReport;
